import { render, staticRenderFns } from "./ProjectPropertyUpdate.vue?vue&type=template&id=481578f4&"
import script from "./ProjectPropertyUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectPropertyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports